import React from 'react';
import { Button, Col, Divider, Row } from 'antd';
import MailIcon from '@BUP/assets/Images/Home/mail_icon.png';
import { getMessageCreatorInfo } from '@BUP/services/BraveUp';
import { useHistory, useLocation } from 'react-router';
import styles from './message-element.module.css';

const ModeBupMessage = ({ dateText, messageText, message }) => {
  const history = useHistory();
  const location = useLocation();
  const { messageCreator } = getMessageCreatorInfo(message);

  return (
    <>
      <Button
        type="text"
        onClick={() => {
          history.push({
            pathname: `/modebup/direct`,
            mainMessage: message,
            messageCreator,
            prevLocation: location,
          });
        }}
        className={styles.button_container}
      >
        <Row className={styles.message_wrapper}>
          <Col lg={8} className={styles.icon_wrapper}>
            <img className={styles.icon} src={MailIcon} alt="Ícono Modo Bup" />
          </Col>
          <Col lg={16} className={styles.text_wrapper}>
            <h5 className={styles.message_text}>{messageText}</h5>
            <h5 className={styles.date_text}>{dateText}</h5>
          </Col>
        </Row>
      </Button>
      <Divider className={styles.divider} />
    </>
  );
};

export default ModeBupMessage;
